module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "custom-contact-columns"
  }, [_c('TitleTrigger', {
    staticClass: "custom-contact-columns__trigger",
    attrs: {
      "props": 1
    }
  }), _c('div', {
    staticClass: "custom-contact-columns__container"
  }, [_c('div', {
    staticClass: "custom-contact-columns__title",
    class: {
      active: _vm.titleActive
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-contact-columns__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.subtitle)
    }
  }), _c('div', {
    staticClass: "custom-contact-columns__row"
  }, [_c('div', {
    staticClass: "custom-contact-columns__col-left"
  }, [_c('div', {
    staticClass: "custom-contact-columns__hours-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.hours)
    }
  }), _c('div', {
    staticClass: "custom-contact-columns__hours-body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.hours_body)
    }
  }), _vm._l((_vm.props.links), function(item, i) {
    return _c('a', {
      staticClass: "custom-contact-columns__link",
      attrs: {
        "href": item.href
      }
    }, [_c('div', {
      staticClass: "custom-contact-columns__link--text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])
  }), _c('div', {
    staticClass: "custom-contact-columns__map",
    domProps: {
      "innerHTML": _vm._s(_vm.props.google_map_embed)
    }
  })], 2), _c('div', {
    staticClass: "custom-contact-columns__col-right"
  }, [_c('FormContact')], 1)])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a280a21a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-contact-columns/custom-contact-columns.pug
// module id = 660
// module chunks = 1